// The dashboard card's RPM tag (owner-approved 2026-09-29).
//
// The tag used to mean only "has an rpm_master row" (rpm_status "Y"); on 09-29,
// 36 of the 65 tagged patients had stopped sending readings. The dashboard now
// also sends rpm_last_reading (newest BP / weight reading, naive clinic time
// "YYYY-MM-DDTHH:MM:SS", or null) and rpm_enroll_status (rpm_master.status):
//   * green "RPM"            - a reading in the last 30 days
//   * muted "RPM · inactive" - enrolled (status A, or P with a reading) and no
//                              reading in 30 days; title "Last reading <date>"
//                              or "No readings yet"
//   * no tag                 - pending (P) with no reading ever
// A gateway that does not send rpm_last_reading yet keeps the old plain tag.
// The CareIQ care gap (api/rpm_devices/rpm_activity.py) uses the same 30 days.
import { clinicDateKey, parseStamp } from "./visitflow.js";

export const RPM_ACTIVE_DAYS = 30;
const DAY_MS = 86400000;
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "Sep 20, 2026" (clinic date).
export const fmtReadingDay = (d) => {
  const [y, m, day] = clinicDateKey(d).split("-");
  return `${MONTHS[Number(m) - 1]} ${Number(day)}, ${y}`;
};

// { active, label, title } or null (no tag).
export const rpmTag = (data, now = new Date()) => {
  if (!data || data.rpm_status !== "Y") return null;
  if (!Object.prototype.hasOwnProperty.call(data, "rpm_last_reading")) {
    return { active: true, label: "RPM", title: "" };
  }
  const last = parseStamp(data.rpm_last_reading);
  const status = String(data.rpm_enroll_status ?? "").trim().toUpperCase();
  const title = last ? `Last reading ${fmtReadingDay(last)}` : "No readings yet";
  if (last && now.getTime() - last.getTime() <= RPM_ACTIVE_DAYS * DAY_MS) {
    return { active: true, label: "RPM", title };
  }
  if (status === "A" || (status === "P" && last)) {
    return { active: false, label: "RPM · inactive", title };
  }
  return null;
};
